module.exports = "/assets/packs/images/fa1ea7ab38ea144249a7db49a50ee9b2.png";